
<template>
  <div v-if="
    canPurchaseExtraCards &&
    currentEventParticipants?.length > 0 && 
    !isOffline">
    <AppLinkMessage routeName="Register" :routeParams="{ id: currentPokerRunEvent?.id }"
      :routeQuery="{ includeExtraCard: 'true' }">
      <span class="text-normal-emphasis">You can add an extra card to your hand(s) before the third card is
        dealt.</span>
      <span class="text-normal-emphasis font-bold">Buy now!</span>
    </AppLinkMessage>
  </div>
</template>
<script setup lang="ts">
import { useEventParticipantStore } from "@/store/EventParticipant";
import { storeToRefs } from "pinia";
import { onMounted, watch, computed, ref } from "vue";
import { useRouter } from 'vue-router';

const router = useRouter();
const {
  currentEventParticipants,
  currentPokerRunEvent,
  canPurchaseExtraCards,
  isOffline,
  cartItems
} = storeToRefs(useEventParticipantStore());

const handleClick = () => {
  router.push({
    name: 'EventAddons',
    params: { id: currentPokerRunEvent.value?.id },
    query: { includeExtraCard: 'true' },
  });
};

</script>